angular.module('impactx.landingpage').controller('ApprovalWorkflowDemandCtrl', [
    'dataGen',
    '$redirect',
    '$routeParams',
    ApprovalWorkflowDemandCtrl
]);

function ApprovalWorkflowDemandCtrl(dataGen, $redirect, $routeParams) {
    var self = this;
    self.dehId = $routeParams.dehId;

    (self.init = function () {
        if (self.dehId > 0) {
            getWorkflow();
        }
        else {
            redirectToStatusList();
        }
    })();

    self.redirectToRequestList = function () {
        redirectToStatusList();
    };

    function getWorkflow() {
        return dataGen.getData(self, {dehId: self.dehId}, '/landingpage/approvalworkflow/demand');
    }

    function redirectToStatusList() {
        $redirect.redirectTo(null, '/demandlist');
    }
}